import type { NodeViewProps } from "@tiptap/react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

/**
 * Enum field sub-view — dropdown for predefined option values.
 *
 * Reads available options from the node's `options` attribute (string array)
 * and stores the selected value in the `value` attribute.
 *
 * Used for atomic metadata fields with predefined option sets.
 */
export function EnumFieldView({ node, updateAttributes }: NodeViewProps) {
  const options = (node.attrs.options as string[]) || [];
  const currentValue = (node.attrs.value as string) || undefined;
  const label = node.attrs.label as string;
  const guidance = node.attrs.guidance as string | undefined;

  return (
    <Select value={currentValue} onValueChange={(value) => updateAttributes({ value })}>
      <SelectTrigger className="w-48">
        <SelectValue placeholder={guidance || `Select ${label.toLowerCase()}...`} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option} value={option}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
